import classnames from 'classnames'
import { Tooltip } from 'react-tooltip'

export const BUTTON_ROUND_LG_STYLES =
  'min-w-[35px] min-h-[35px] sm:min-w-[37px] sm:min-h-[37px] rounded-full flex items-center justify-center disabled:opacity-60'

interface IProps {
  form?: string
  type: 'button' | 'submit' | 'div'
  loading?: boolean
  disabled?: boolean
  children: any
  className?: string
  callback?: (e?: any) => void
  tooltip?: {
    id: string
    message: string
    place?: any
  }
}

export const ButtonRoundLg = ({ form, type, loading, disabled, children, className, callback, tooltip }: IProps) => {
  let component = (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classnames(BUTTON_ROUND_LG_STYLES, className)}
      onClick={() => {
        if (callback) {
          callback()
        }
      }}
    >
      {children}
    </div>
  )

  if (type === 'submit') {
    component = (
      <button form={form} className={classnames(BUTTON_ROUND_LG_STYLES, className)} type='submit' disabled={loading}>
        {children}
      </button>
    )
  }

  if (type === 'button') {
    component = (
      <button
        className={classnames(BUTTON_ROUND_LG_STYLES, className)}
        type='button'
        disabled={loading || disabled}
        onClick={() => {
          if (callback) {
            callback()
          }
        }}
      >
        {children}
      </button>
    )
  }

  return tooltip && !loading && !disabled ? (
    <div data-tooltip-id={tooltip.id} data-tooltip-content={tooltip.message}>
      {component}
      <Tooltip
        id={tooltip.id}
        place={tooltip.place}
        className='hidden sm:inline-block !bg-surface !text-text border border-border !drop-shadow-sm z-[60]'
      />
    </div>
  ) : (
    component
  )
}
